import React, { useEffect, useRef, useState } from "react"
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, } from 'react-bootstrap';
import Topbar from "../Components/Topbar/Topbar";
import { connect } from "react-redux";
import Sidebar from "../Components/Sidebar/Sidebar";
import LoadingSpinner from "../Components/LoadingSpinner";
import soujson from './sou.json'
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import Select from 'react-select';
import moment from "moment/moment";
import { exportAllSou, exportExpiredAllSou, formatTime, getSouList, statusText } from "../Utils/utils";
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
import SuccessModal from "../Components/Modals/SuccessModal";
import WarningModal from "../Components/Modals/WarningModal";
import PendingModal from "../Components/Modals/PendingModal";
import config from "../config/config";
import axios from "axios";
import ArchiveModal from "../Components/Modals/ArchiveModal";
import { exportAsPDF } from "../Utils/ExportData";
import { TimetoConvert, TimeUtils } from "../Utils/TimeUtils";
import CustomSearch from "../Components/CustomSearch";
import EditSou from "./EditSou";
import momenttimezone from "moment-timezone";
import NotesModalNew from "../Components/Modals/NotesModalNew";




const Sou = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [key, setKey] = useState('ready')
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSubmitWait, setIsSubmitWait] = useState(false);
  const [isSubmitPending, setIsSubmitPending] = useState(false);
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [noteuserId, setNoteUserId] = useState('');
  const [isSuccessShow, setIsSuccessShow] = useState(false);
  const [isSuccessShowRoll, setIsSuccessShowRoll] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShowPending, setIsShowPending] = useState(false);
  const [isShowRoll, setIsShowRoll] = useState(false);
  const [userId, setUserId] = useState('');
  const [isShow2, setIsShow2] = useState(false);
  const [archiveShow, setArchiveShow] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [isSuccessShow2, setIsSuccessShow2] = useState(false);
  const pageRef = useRef();
  const navigate = useNavigate();
  const handleFilterChange = (e) => { setFilterText(e.target.value); };
  const [souModal, setSouModal] = useState(false);
  const [souData, setSouData] = useState([]);
  const [notesShow, setNotesShow] = useState(false);
  const [userNote, setUserNote] = useState('');
  const [noteNew, setNoteNew] = useState('');





  const newTime = (time) => {
    let newMatch = time.split('&&&')
    let newArray = []
    newMatch.map((a) => {
      if (a !== "") {
        newArray.push(a)
      }
    })
    return newArray
  }
  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    },
  ];


  const columns = [
    {
      id: 1,
      name: "Student Id",
      width: '105px',
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LD_SID}
        </div>
    },
    {
      id: 4,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row" style={{ fontSize: '12px' }}>
            <div className='cell-upper'>{row.RANK}</div>
          </div>
        </>,
      sortable: true,
      selector: (row) => row.RANK,
      width: "80px"
    },
    {
      id: 4,
      name: "First Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: true,
      selector: (row) => row.FIRSTNAME,
      width: "110px",
    },
    {
      id: 5,
      name: "Last Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: true,
      selector: (row) => row.LASTNAME,
      width: "130px",
    },
    {
      id: 7,
      name: "Contact Info",
      cell: (row) =>
        <>
          <div className="row" style={{ padding: '5px 0px' }}>
            <div className='cell-lower' style={{ fontSize: '12px' }}>{row.HOME_EMAIL}</div>
            <div className='cell-lower' style={{ fontSize: '12px' }}>{row.WORK_EMAIL}</div>
            <div style={{ fontSize: '12px' }}>{row.PHONE}</div>
          </div>
        </>,
      width: "210px"
    },
    // {
    //   id: 8,
    //   name: "Availability in EST",
    //   cell: (row) =>
    //     <>
    //       <div className="row py-2">
    //         {row?.MON_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>MON - {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)}</div>}
    //         {row?.TUE_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>TUE - {TimetoConvert(row.TUE_FROM, row.TUE_TO, row.TIMEZONE)} </div>}
    //         {row?.WED_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>WED - {TimetoConvert(row.WED_FROM, row.WED_TO, row.TIMEZONE)} </div>}
    //         {row?.THUR_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>THUR - {TimetoConvert(row.THUR_FROM, row.THUR_TO, row.TIMEZONE)} </div>}
    //         {row?.FRI_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>FRI - {TimetoConvert(row.FRI_FROM, row.FRI_TO, row.TIMEZONE)} </div>}
    //         {row?.SAT_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>SAT - {TimetoConvert(row.SAT_FROM, row.SAT_TO, row.TIMEZONE)} </div>}
    //         {row?.SUN_FROM &&
    //           <div className='cell-up' style={{ fontSize: '12px' }}>SUN - {TimetoConvert(row.SUN_FROM, row.SUN_TO, row.TIMEZONE)} </div>}
    //       </div>
    //     </>,
    //   width: "160px"
    // },
    {
      id: 8,
      name: "Schedule in EST",
      cell: (row) =>
        <div className='' style={{ fontSize: '12px' }}>
          <div className="row pt-2 pb-3">
            {newTime(row?.selected_schedule).map((a) => (
              <>
                {a !== "" ?
                  <div className='cell-up' style={{ fontSize: '12px' }}>{a}</div>
                  : null}
              </>
            ))}
          </div>
        </div>,
      selector: (row) => row.PHONE,
      width: "160px"
    },
    {
      id: 10,
      name: "Instructor",
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.instructor_name}
        </div>,
      sortable: true,

      selector: (row) => row.instructor_name,
      width: "140px"
    },
    {
      id: 9,
      name: "Timezone",
      sortable: true,
      selector: (row) => row.TIMEZONE,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE}
        </div>
      ),
      width: "150px"
    },
    {
      id: 11,
      name: "Start Date",
      sortable: true,
      selector: (row) => row.new_start_date,
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        {moment(row?.new_start_date).format('MM/DD/YYYY')}
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 12,
      name: "End Date",
      sortable: true,
      selector: (row) => row.new_start_date,

      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{row?.new_end_date ? moment(row?.new_end_date).format('MM/DD/YYYY') : row.COURSE_NUMBER.split('-')[1]?.startsWith('30')
          ? moment(row.new_start_date).add(3, 'weeks').format('MM/DD/YYYY')
          : moment(row.new_start_date).add(10, 'weeks').format('MM/DD/YYYY')
        }</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 13,
      name: "Student Type",
      selector: (row) =>
        <div style={{ fontSize: '12px' }}>
          {row.FLEX == "T" ? "FLEX" : "GROUP"}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 14,
      name: "Course No.",
      selector: (row) => row.serialized_course_number,
      sortable: true,
      width: "125px",
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{row.serialized_course_number}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      id: 15,
      name: "Course Type",
      selector: (row) =>
        <div style={{ fontSize: '12px' }}>
          {row.COURSETYPE}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "120px"
    },
    {
      id: 16,
      name: "Uploaded on",
      sortable: true,
      selector: (row) => row.created_on,
      cell: (row) => <div style={{ fontSize: '12px' }}
      >{moment(row.created_on).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "140px"
    },
    {
      id: 17,
      name: "SOU Sent on",
      sortable: true,
      selector: (row) => row.sou_sent_on,
      cell: (row) => <div style={{ fontSize: '12px' }}
      >
        {moment(row.sou_sent_on.split('+')[0]).format('MM/DD/YYYY hh:mm a')}
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "150px"
    },
    {
      id: 18,
      name: "SOU Status",
      sortable: true,
      selector: (row) => row.status_id,
      cell: (row) => <div style={{ fontSize: '12px' }}
      >
        {statusText(row.status_id)}
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "130px"
    },
    {
      id: 19,
      name: "SOU Signed on ",
      sortable: true,
      selector: (row) => row.sou_signed_on,
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
      >
        {row.sou_signed_on == null ? '' :
          moment(row.sou_signed_on.split('+')[0]).format('MM/DD/YYYY hh:mm a')}
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "150px"
    },
    // {
    //   id: 19,
    //   name: "Notes",
    //   cell: (row) => <div style={{ padding: '10px 5px' }}
    //   >{row.notes}</div>,
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   width: "400px"
    // },
    {
      id: 19,
      name: "Action",
      width: "140px",
      cell: (row) =>
        <div className='cell-link'>
          <>
            {row.sou_signed ? (
              <span
                onClick={() => {
                  navigate(`/souDetail/${row.generated_hash}`, { state: { download: true } });
                }}
              >
                <i className="text-warning fas fa-download ml-3 mr-3" title="Download"></i>
              </span>
            ) : null}
            <i className="text-success far fa-edit ml-3 mr-3" title="Edit"
              onClick={() => {
                setSouModal(true);
                setSouData(row);
              }}></i>


            {statusText(row.status_id) === "Pending" &&
              <i className="text-green fas fa-redo mr-3 ml-3" title="Send SOU again"
                onClick={() => {
                  setUserId(row?.id)
                  setIsShowPending(true)
                  setSouData(row);
                }}
              >
              </i>
            }


            <i className="text-danger fas fa-undo ml-3 mr-3" title="Roll Back"
              onClick={() => {
                setUserId(row?.id)
                setIsShowRoll(true)
              }}></i>

            <i className="text-info fas fa-archive ml-3" title="Archive"
              onClick={() => {
                setArchiveShow(true)
                setNoteUserId(row?.LD_SID)
              }}></i>

            {row.status_id == 5 ?
              <Link to={"/sou/" + row.generated_hash} target="_blank">
                <i className="text-secondary fas fa-eye ml-3" title="View"></i>
              </Link>
              : null}

            {row?.notes?.trim() ? <i className="text-warning far fa-sticky-note mr-2" title="Notes"
              onClick={() => {
                setNotesShow(true)
                setNoteUserId(row?.LD_SID)
                setUserNote(row?.notes)
              }}>
            </i>
              : ""}
          </>
        </div>,
      // selector: (row) => <><i class="far fa-sticky-note"></i> <i class="fas fa-archive"></i></>,
    },
  ];



  const getAllSou = async () => {

    setIsLoading(true)
    var res = await getSouList()
    if (res.status == 200) {
      setRegualarClasses(res?.data)
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getAllSou()
  }, [reloadData])




  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));
  const LinearIndeterminate = () => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  };


  const exportExpired = async () => {
    var res = await exportExpiredAllSou()
    if (res.data.status == 200) {
      setIsSuccessShow(true)
      // toast.success('Data exported successfully')
      window.location.href = res.data.data
    }
  }

  const exportAll = async () => {
    var res = await exportAllSou()
    if (res.data.status == 200) {
      setIsSuccessShow(true)
      window.location.href = res.data.data
    }
  }
  const removeStudent = async (id) => {
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/rollback-student', {
      id: id
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        setIsShowRoll(false)
        setIsSuccessShowRoll(true)
      })
      .catch((error) => {
        console.log(error)
      });
  }







  const onSubmit = async () => {
    if (!souData) {
      console.error("souData is null or undefined!");
      return;
    }

    var temp = [];

    temp.push({
      mainClassNumber: souData?.serialized_course_number,
      availableStartDate: souData?.new_start_date,
      students: Array.isArray(souData) ? souData : [souData],
    });


    setIsLoading(true);

    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;

    await axios.post(path + '/classes/send-sou', { data: temp }, {
      headers: { 'Content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        if (response.data.status === 200) {
          setIsLoading(false);
          setIsSuccessShow2(true)
          setIsShowPending(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response ? error.response.data : error.message);
        setIsLoading(false);
        setIsShowPending(false);
      });
  };







  const onProceedRoll = async () => {
    removeStudent(userId)
  }


  const onProceed = () => {
    setIsShow(false)
    exportExpired()
  }

  const onProceedPending = () => {
    setIsShowPending(true);
    onSubmit()
  }

  const onProceed2 = () => {
    setIsShow2(false)
    exportAll()
  }
  const onClose = () => {
    setIsSuccessShow(false)
  }

  const onCloseRoll = () => {
    setIsSuccessShowRoll(false)
    getAllSou()
  }


  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                    <div className="row">
                      <div className="col-lg-5">
                        <div className='heading-text'>
                          Sou
                        </div>
                      </div>
                      <div className="col-lg-2">
                        {regualarClasses.length > 0 && (
                          <div className="main-btn2"
                            onClick={() => {
                              setIsShow(true)
                            }}
                          >
                            Export Expired Data
                          </div>
                        )}
                      </div>
                      <div className="col-lg-2">
                        {regualarClasses.length > 0 && (
                          <div className="main-btn2"
                            onClick={() => {
                              setIsShow2(true)
                            }}
                          >
                            Export All SOU
                          </div>
                        )}
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="row mb-4">
                      <div className="col-md-12">
                        {regualarClasses.length > 0 ?
                          <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                            <div className="card-body m-p-0 p-0">
                              <DataTableExtensions
                                columns={columns}
                                data={regualarClasses.filter((item) =>
                                  Object.values(item).some((value) => {
                                    const strValue = String(value).toLowerCase();
                                    if (item.status_id) {
                                      const extracted = statusText(item.status_id)
                                      if (extracted.toLowerCase().startsWith(filterText.toLowerCase().trim())) {
                                        return true;
                                      }
                                    }
                                    return strValue.includes(filterText.toLowerCase().trim());
                                  })
                                )}
                                // data={regualarClasses.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase())))}
                                print={false}
                                export={false}
                                filter={false}
                              >
                                <DataTable
                                  pagination
                                  // paginationComponentOptions={paginationComponentOptions}
                                  // selectableRows
                                  conditionalRowStyles={conditionalRowStyles}
                                  // selectableRowsNoSelectAll={true}
                                  // onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                                  persistTableHead
                                  progressComponent={<LinearIndeterminate />}
                                  paginationPerPage={10}
                                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                  highlightOnHover
                                  className="custom-table-border"
                                  customStyles={{
                                    headCells: {
                                      style: {
                                        backgroundColor: '#8A8A8A',
                                        color: '#ffffff',
                                      },
                                    },
                                  }}
                                />
                              </DataTableExtensions>
                            </div>
                          </div>
                          :
                          <div className="no-record">
                            There are no records to display.
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {isSuccessShow == true ?
          <SuccessModal
            isSuccessShow={isSuccessShow}
            setIsSuccessShow={setIsSuccessShow}
            onClose={onClose}
          />
          : null}
        {isSuccessShowRoll == true ?
          <SuccessModal
            isSuccessShow={isSuccessShowRoll}
            setIsSuccessShow={setIsSuccessShowRoll}
            onClose={onCloseRoll}
          />
          : null}
        {isShowPending && (
          <PendingModal
            isShowPending={isShowPending}
            setIsShowPending={setIsShowPending}
            onProceedPending={onProceedPending}
          />
        )}

        {notesShow == true ?
          <NotesModalNew
            notesShow={notesShow}
            setNotesShow={setNotesShow}
            noteUserId={noteuserId}
            userNote={userNote}
            setNoteNew={setNoteNew}
          />
          : null}


        {isShow == true ?
          <WarningModal
            isShow={isShow}
            setIsShow={setIsShow}
            onProceed={onProceed}
          />
          : null}
        {isShow2 == true ?
          <WarningModal
            isShow={isShow2}
            setIsShow={setIsShow2}
            onProceed={onProceed2}
          />
          : null}
        {isShowRoll == true ?
          <WarningModal
            isShow={isShowRoll}
            setIsShow={setIsShowRoll}
            onProceed={onProceedRoll}
          />
          : null}
        {archiveShow == true ?
          <ArchiveModal
            archiveShow={archiveShow}
            setArchiveShow={setArchiveShow}
            noteUserId={noteuserId}
            setReloadData={setReloadData}
          />
          : null}
        {souModal === true ?
          <EditSou
            souModal={souModal}
            setSouModal={setSouModal}
            souData={souData}
            setSouData={setSouData}
          />
          : null
        }
        {isSuccessShow2 == true ?
          <SuccessModal
            isSuccessShow={isSuccessShow2}
            setIsSuccessShow={setIsSuccessShow2}
            onClose={onClose}
          />
          : null}
      </div>
    </>
  )
}
export default Sou

